import React from 'react';
import HeaderNavigationDropdown from './HeaderNavigationDropdown';
import HeaderNavigationName from './HeaderNavigationItemName';

const HeaderNavigationItem = ({ category }) => {
    const [opened, setOpened] = React.useState(false);
    const handleClickMobile = () => setOpened(!opened);

    return (
        <div className="navigation-item">
            <HeaderNavigationName
                mobileClassName={opened ? 'opened' : ''}
                onClickMobile={handleClickMobile}
                link={category.link}
                name={category.name}
                hasList={!!category.items}
            />
            {category.items && <HeaderNavigationDropdown button={category.button} items={category.items} />}
        </div>
    );
};

export default HeaderNavigationItem;
